import React from "react";
import { Bar } from "react-chartjs-2";
import type { ChartData, Plugin } from "chart.js";

import RebetLoaderJs from "../RebetLoader/RebetLoader";

import "./chartSetup";
import { buildChartOptions } from "./chartTheme";

const RebetLoader = RebetLoaderJs as React.ComponentType<{
  width: number;
  height: number;
}>;

export interface BarChartProps {
  data: ChartData<"bar">;
  // chart-specific options, deep-merged onto the shared theme
  optionsOverride?: Record<string, unknown>;
  // flips to a horizontal bar (indexAxis: "y")
  horizontal?: boolean;
  // per-instance plugins, e.g. [ChartDataLabels]
  plugins?: Plugin<"bar">[];
  isLoading?: boolean;
  loaderSize?: number;
}

const loaderWrapperStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  height: "100%",
};

const BarChart: React.FC<BarChartProps> = ({
  data,
  optionsOverride,
  horizontal = false,
  plugins,
  isLoading = false,
  loaderSize = 100,
}) => {
  if (isLoading) {
    return (
      <div style={loaderWrapperStyle}>
        <RebetLoader width={loaderSize} height={loaderSize} />
      </div>
    );
  }

  const options = buildChartOptions({
    ...(horizontal ? { indexAxis: "y" } : {}),
    ...optionsOverride,
  });

  return <Bar data={data} options={options as never} plugins={plugins} />;
};

export default BarChart;
